import React from 'react';
import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';

export default function StatCard({ label, value, icon: Icon, color = 'text-primary', href }) {
  const inner = (
    <Card className={`p-5 flex items-start gap-4 hover:shadow-md transition-shadow ${href ? 'cursor-pointer hover:-translate-y-0.5 transition-all' : ''}`}>
      <div className={`p-2.5 rounded-lg bg-muted ${color}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div>
        <p className="text-2xl font-bold tracking-tight">{value}</p>
        <p className="text-xs text-muted-foreground mt-0.5">{label}</p>
      </div>
    </Card>
  );
  return href ? <Link to={href}>{inner}</Link> : inner;
}